import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"menu\"><path d=\"M14 15v1H2v-1h12Zm4-10v1H2V5h16ZM2 11v-1h16v1H2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol